import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createCaseState = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createCaseState($caseTypeId: Int!, $state: String!, $position: Int!) {
          createCaseState(caseTypeId: $caseTypeId, state: $state, position: $position ) { id state error message lowLevelErrorMessage}
        }`),
      variables: { caseTypeId: data.caseTypeId, state: data.state, position: data.position }
    }
  )
  return response.data.createCaseState
}

export const updateCaseState = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation updateCaseState($stateId: Int!, $state: String!, $position: Int!) {
          updateCaseState(stateId: $stateId, state: $state, position: $position ) { id state error message lowLevelErrorMessage}
        }`),
      variables: { stateId: data.stateId, state: data.state, position: data.position }
    }
  )
  return response.data.updateCaseState
}

export const deleteCaseState = async (stateId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteCaseState($stateId: Int!) {
        deleteCaseState(stateId: $stateId) { error message lowLevelErrorMessage}
      }`),
      variables: { stateId: stateId }
    }
  )
  return response.data.deleteCaseState
}
